import "./ListDetailLocalSiteQuery.scss"
import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import DatatableLocalSite from "../../../components/datatableLocalSite/DatatableTicketSite";

const ListDetailLocalSiteQuery = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
        <div className="listContainer">
            <Navbar/>
            <DatatableLocalSite columns={columns}/>
            <br/>
            <br/>
            <br/>
            <br/>

        </div>
    </div>
  )
}

export default ListDetailLocalSiteQuery